import {
  Box,
  IconButton,
  Badge,
  Center,
  Flex,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Button,
  useColorModeValue,
} from "@chakra-ui/react";
import Image from "next/image";
import placeH from "../public/PNU_logo.png";
import Link from "next/link";
import { FiArrowDown } from "react-icons/fi";
import { HiOutlineDotsCircleHorizontal } from "react-icons/hi";

function FullCard({ link, query, img, slug, name }) {
  return (
    <Box
      boxShadow="outline"
      boxSizing="content-box"
      boxSize={["80", "xs", "96"]}
      borderRadius="3xl"
      // border="5px solid"
      borderColor="blue.100"
      overflow="hidden"
      p={2}
    >
      <Flex justifyContent="flex-start" m={4}>
        <Menu>
          <MenuButton
            as={IconButton}
            aria-label="Options"
            icon={<HiOutlineDotsCircleHorizontal size={20} />}
            size="sm"
            variant="outline"
          />
          <MenuList>
            <MenuItem command="⌘C">Copy Link</MenuItem>
            <MenuItem command="⌘D">Download</MenuItem>
            <MenuItem command="⌘R">Report</MenuItem>
            <MenuItem command="⌘S">Share</MenuItem>
          </MenuList>
        </Menu>
      </Flex>
      <Center>
        <Image
          src={img ? img : placeH}
          layout="intrinsic"
          objectFit="fill"
          width={"125px"}
          height={"125px"}
          alt="Logo"
        />
      </Center>
      <Box p={[2, 4, 6]} m={[2, 4, 6]}>
        <Box d="flex" alignItems="baseline">
          <Badge borderRadius="full" px="2" colorScheme="pink">
            Solved
          </Badge>
          <Box
            fontWeight="semibold"
            letterSpacing="wide"
            fontSize="xs"
            textTransform="uppercase"
            ms="2"
          >
            besd
          </Box>
        </Box>
        <Box m="1" fontWeight="semibold" as="h2" lineHeight="tight" isTruncated>
          {slug}
        </Box>
        <Box fontSize="md">
          {name}
          <Box as="span" color="gray.600" fontSize="sm">
            / wk
          </Box>
        </Box>
        <Flex mt="2" alignItems="center" justifyContent="space-between">
          {/* {
        (view = false ? (
          <Box d="flex" alignItems="center" justifyContent="flex-start">
            <IconButton
              icon={<ViewIcon color="gray.400" />}
              bg={"gray.100"}
              mx={1}
            ></IconButton>
          </Box>
        ) : (
          ""
        ))
      } */}
          <>
            <IconButton
              aria-label="Chevron icon"
              icon={<FiArrowDown color="teal" />}
              bg={"powderblue"}
              fontSize={28}
              mx={1}
            ></IconButton>
            <Link href={slug ? slug : `/${query}/${encodeURIComponent(link)}/`} prefetch={false}>
              Select
            </Link>
          </>
        </Flex>
      </Box>
    </Box>
  );
}
function SimpleCard({ img, slug, name }) {
  return (
    <Box
      boxShadow="outline"
      boxSizing="content-box"
      boxSize={["64"]}
      // maxW="xs"
      borderRadius="2xl"
      // border="3px solid"
      borderColor="teal.300"
      overflow="hidden"
    >
      <Center
        bg={useColorModeValue("powderblue", "cyan.50")}
        m={3}
        p={1}
        borderRadius="2xl"
      >
        <Image
          src={img ? img : placeH}
          layout="intrinsic"
          objectFit="fill"
          width={"125px"}
          height={"125px"}
          alt="Logo"
        />
      </Center>
      <Center>
        <Box
          mx="2"
          fontWeight="semibold"
          as="h3"
          lineHeight="tight"
          isTruncated
        >
          {name ? name : slug}
        </Box>
      </Center>
      <Flex my={4} alignItems="center" justifyContent="center">
        <Link href={slug} passHref prefetch={false}>
          <Button aria-label="Select">Select</Button>
        </Link>
      </Flex>
    </Box>
  );
}

export function Card({ link, query, img, slug, simple, name }) {
  if (simple) {
    return (
      <SimpleCard img={img} link={link} slug={slug} name={name} query={query} />
    );
  }
  return (
    <FullCard slug={slug} img={img} link={link} name={name} query={query} />
  );
}
